module.exports = __webpack_public_path__ + "img/spoken_reading_voice1.536b8ac3.svg";